import React from 'react';
import resolvePath from '../../../../../misc/resolvePath';
import Tabs from '../../../../elements/Tabs/old';

// TODO: replace tabs with new component

export default class MapTabs extends React.PureComponent {
    render() {
        let {i18n, event} = this.props;

        return (
            <Tabs selectedTabStyle={event._local.styles.button_secondary}>
                {event.map_url ? (
                    <button type="button" selected={isEventMapSelected()} onClick={this.handleSelectEventMap.bind(this)}>
                        {i18n['label.map']}
                    </button>
                ) : null}
                {event.exhibitors_map_url ? (
                    <button type="button" selected={isExhibitorsMapSelected()} onClick={this.handleSelectExhibitorsMap.bind(this)}>
                        {event.settings.exhibitors_map_label || i18n['label.exhibitors']}
                    </button>
                ) : null}
            </Tabs>
        );
    }
    handleSelectEventMap() {
        if (!isEventMapSelected()) {
            app.history.replace(resolvePath(app.history.location.pathname, '..'));
        }
    }
    handleSelectExhibitorsMap() {
        if (!isExhibitorsMapSelected()) {
            app.history.replace(resolvePath(app.history.location.pathname, 'exhibitors'));
        }
    }
}

function isEventMapSelected() {
    return app.history.location.pathname.match(/map$/);
}

function isExhibitorsMapSelected() {
    return app.history.location.pathname.match(/exhibitors$/);
}
